function StaffPrioritiesProvider() {
    let options = {};

    this.setOptions = function (config) {
        options = config;
    };

    this.$get = () => options;
}

/**
 * @ngdoc service
 * @module BB
 * @name StaffPriorities
 *
 * @return {object} options
 *
 * @description
 * Returns a set of configuration options for staff priorities
 */
angular
    .module('BB')
    .provider('StaffPriorities', StaffPrioritiesProvider);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/staff_priorities.provider.js